import {Inject, Injectable} from '@angular/core';
import {RequestService} from "@services/http/request/request.service";
import {APP_CONFIG, AppConfig} from "@src/app.config";
import {map, Observable} from "rxjs";

export interface OnboardingStepConfig {
  description: string;
  requiredFields: string[];
}

export interface OnboardingStep {
  id: string;
  key: string;
  title: string;
  phaseKey: string;
  sequence: number;
  createdAt: string;
  updatedAt: string;
  config: OnboardingStepConfig;
  dependsOn: string[];
}

export type OnboardingProgressStatus = "completed" | "pending" | "not_started";

export interface OnboardingProgress {
  status: OnboardingProgressStatus;
  data: any | null;
}

export interface OnboardingStepProgress {
  step: OnboardingStep;
  progress: OnboardingProgress;
}

@Injectable({
  providedIn: 'root',
})
export class UserOnboardingApiService {
  private readonly base: string;

  constructor(
    private request: RequestService,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {
    this.base = `${this.appConfig.angularEndpoint}/userOnboarding`;
  }

  getProgress(): Observable<OnboardingStepProgress[]> {
    const url = `${this.base}/onboardingProgress`;
    return this.request.get(url).pipe(map(r => r.body))
  }
}
